/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Mk_Price_DaysInputs */

const en_mk_price_days = /** @type {(inputs: Mk_Price_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`per ${i?.days} days`)
};

const id_mk_price_days = /** @type {(inputs: Mk_Price_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`per ${i?.days} hari`)
};

/**
* | output |
* | --- |
* | "per {days} days" |
*
* @param {Mk_Price_DaysInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_days = /** @type {((inputs: Mk_Price_DaysInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_DaysInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_days(inputs)
	return en_mk_price_days(inputs)
});